<h3>
    <a ng-if="!readonly" ng-click="viewDetails($event, item)" ng-bind-html="item.displayName|cHighlight:highlight"></a> <span ng-if="item.updated" class="fa fa-check" style="color: green"></span>
    <span class="title" ng-if="readonly" ng-bind-html="item.displayName|cHighlight:highlight"></span> <span ng-if="item.updated" class="fa fa-check" style="color: green"></span>
</h3>
<div class="property-container">
    <ul class="workflow-property-list">
        <li>{{item.userTypeLabel|translate}}</li>
        <li ng-bind-html="item.userRoleName|cHighlight:highlight"></li>
        <li ng-bind-html="item.userName|cHighlight:highlight"></li>
        <li ng-if="item.jobTitle" ng-bind-html="item.jobTitle|cHighlight:highlight"></li>
        <li ng-if="item.firstWorkUnit" ng-bind-html="item.firstWorkUnit|cHighlight:highlight"></li>
        <li>{{'admin.usersView.created'|translate}}: {{ item.created | cDate }}</li>
        <li ng-if="item.metadata && item.metadata !== ''" ng-bind-html="item.metadata|cHighlight:highlight">{{item.metadata}}</li>
    </ul>
</div>
